<div class="card settings-hover-colors d-flex flex-row p-2 my-2" (click)="expanded = !expanded" *ngIf="inside == null">
    <div class="card-left">
        <div class="font-size-16 lato-bold">
            <ng-content select=".custom-setting-section-title"></ng-content>
        </div>
        <div class="body-2 mt-1">
            <ng-content select=".custom-setting-section-context"></ng-content>
        </div>
    </div>
    <div class="card-right ml-auto d-flex">
        <div class="my-auto" [hidden]="expanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use></svg></div>
        <div class="my-auto" [hidden]="!expanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use></svg></div>
    </div>
</div>

<div class="custom-body py-2 mx-3" [ngbCollapse]="!expanded" *ngIf="inside == null">
    <ng-content select=".custom-setting-section-body"></ng-content>
</div>

<ng-content *ngIf="inside != null" select=".custom-setting-section-inside-body"></ng-content>
